<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { useDelivererStore } from '../../stores/deliverer';

const route = useRoute();
const router = useRouter();
const store = useDelivererStore();

function active(path: string) {
    return route.path === path || route.path.startsWith(path + '/');
}
</script>

<template>
    <nav
        class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100"
        style="padding-bottom: env(safe-area-inset-bottom, 0px);"
    >
        <div class="grid grid-cols-3">

            <!-- Pedidos -->
            <button
                class="flex flex-col items-center justify-center gap-[3px] py-3 relative border-0 bg-transparent cursor-pointer"
                :style="{ color: active('/pedidos') ? '#F97316' : '#9CA3AF' }"
                @click="router.push('/pedidos')"
            >
                <div class="relative">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="7.5" height="7.5" rx="1.5"
                            :fill="active('/pedidos') ? '#F97316' : '#9CA3AF'" />
                        <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5"
                            :fill="active('/pedidos') ? '#F97316' : '#9CA3AF'" />
                        <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5"
                            :fill="active('/pedidos') ? '#F97316' : '#9CA3AF'" />
                        <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5"
                            :fill="active('/pedidos') ? '#F97316' : '#9CA3AF'" />
                    </svg>
                    <span
                        v-if="store.pendingCount > 0"
                        class="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-[3px] rounded-full text-[10px] font-bold text-white flex items-center justify-center"
                        style="background: #EF4444; line-height: 1;"
                    >
                        {{ store.pendingCount > 99 ? '99+' : store.pendingCount }}
                    </span>
                </div>
                <span class="text-[11px] font-semibold">Pedidos</span>
            </button>

            <!-- Hoje -->
            <button
                class="flex flex-col items-center justify-center gap-[3px] py-3 border-0 bg-transparent cursor-pointer"
                :style="{ color: active('/hoje') ? '#F97316' : '#9CA3AF' }"
                @click="router.push('/hoje')"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9"
                        :stroke="active('/hoje') ? '#F97316' : '#9CA3AF'" stroke-width="2"/>
                    <path d="M12 7v5l3 3"
                        :stroke="active('/hoje') ? '#F97316' : '#9CA3AF'"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="text-[11px] font-semibold">Hoje</span>
            </button>

            <!-- Conta -->
            <button
                class="flex flex-col items-center justify-center gap-[3px] py-3 border-0 bg-transparent cursor-pointer"
                :style="{ color: active('/conta') ? '#F97316' : '#9CA3AF' }"
                @click="router.push('/conta')"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="3.5"
                        :stroke="active('/conta') ? '#F97316' : '#9CA3AF'" stroke-width="2"/>
                    <path d="M4 20c0-3.866 3.582-7 8-7s8 3.134 8 7"
                        :stroke="active('/conta') ? '#F97316' : '#9CA3AF'"
                        stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span class="text-[11px] font-semibold">Conta</span>
            </button>

        </div>
    </nav>
</template>
